module.exports = __webpack_public_path__ + "img/icons BFr_15.46b8a595.svg";